/**
 * Inline SVG icon set. No icon dependency: fifteen 24x24 stroke paths weigh
 * far less than a package, and they inherit currentColor so theming is free.
 */
type Name =
  | 'dashboard' | 'orders' | 'prepress' | 'production' | 'dispatch' | 'stock'
  | 'payments' | 'reports' | 'chevron' | 'sun' | 'moon' | 'panel' | 'logout'
  | 'list' | 'calendar' | 'truck' | 'box' | 'reel' | 'drop' | 'chart'
  | 'building' | 'clock' | 'settings' | 'sliders' | 'users'
  | 'star' | 'plus' | 'more';

const PATHS: Record<Name, string> = {
  dashboard: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
  orders: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M9 13h6M9 17h6',
  prepress: 'M12 2 2 7l10 5 10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
  production: 'M2 20h20M4 20V9l5 3V9l5 3V9l5 3v8M7 20v-4h4v4',
  dispatch: 'M1 3h15v13H1zM16 8h4l3 3v5h-7zM5.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  stock: 'M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3M3 8h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 12h6',
  payments: 'M2 7h20v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM2 11h20M6 16h4',
  reports: 'M3 3v18h18M7 15V9M12 17V5M17 13v-4',
  chevron: 'M9 6l6 6-6 6',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
  panel: 'M3 3h18v18H3zM9 3v18',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  calendar: 'M3 4h18v18H3zM3 10h18M8 2v4M16 2v4',
  truck: 'M1 3h15v13H1zM16 8h4l3 3v5h-7z',
  box: 'M21 16V8l-9-5-9 5v8l9 5zM3 8l9 5 9-5M12 13v8',
  reel: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  drop: 'M12 2.7 6.5 8.2a7.8 7.8 0 1 0 11 0z',
  chart: 'M18 20V10M12 20V4M6 20v-6',
  building: 'M4 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18M16 8h2a2 2 0 0 1 2 2v12M8 6h4M8 10h4M8 14h4M8 18h4',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 7 19.4a1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9H1a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 2.6 7a1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 8 2.6V2a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0 1.2 2.9H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  sliders: 'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6',
  users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  // Marks a record as one of today's, on the pre-press lists.
  star: 'M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9z',
  plus: 'M12 5v14M5 12h14',
  // Three dots: a menu of the less-used actions.
  more: 'M5 12h.01M12 12h.01M19 12h.01',
};

export default function Icon({
  name, size = 18, className,
}: { name: Name; size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name].split('M').filter(Boolean).map((seg, i) => (
        <path key={i} d={`M${seg}`} />
      ))}
    </svg>
  );
}

export type IconName = Name;
